import {
  all, call, put, takeLatest,
} from 'redux-saga/effects';
import * as appConstants from 'redux/constants/app.constants';
import * as constants from 'redux/constants/subCategory.constants';
import { getAll, getSubCategoriesHome } from 'services/subCategory.services';

export function* subCategoryGetAll(data = null) {
  try {
    const isReduxAction = data && data.type;
    const subcategories = !isReduxAction && data ? data : yield call(getAll);
    yield put({ type: constants.SUBCATEGORY_GET_ALL_SUCCEEDED, data : subcategories });
  } catch (error) {
    yield put({ type: constants.SUBCATEGORY_GET_ALL_FAILED, error });
  }
}

export function* subCategoryHomeGet(data = null) {
  try {
    const isReduxAction = data && data.type;
    const subcategoriesHome = !isReduxAction && data ? data : yield call(getSubCategoriesHome);
    yield put({ type: constants.SUBCATEGORY_GET_SUBCATEGORIES_HOME_SUCCEEDED, data : subcategoriesHome });
  } catch (error) {
    yield put({ type: constants.SUBCATEGORY_GET_SUBCATEGORIES_HOME_FAILED, error });
  }
}

export function* watchSubCategories() {
  yield all([
    // takeLatest(appConstants.APP_INITIALIZE_REQUESTED, subCategoryGetAll),
    // takeLatest(appConstants.APP_INITIALIZE_REQUESTED, subCategoryHomeGet),
  ]);
}
